import * as React from "react";

const SvgIcnHoldBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M8 5h2a1 1 0 011 1v12a1 1 0 01-1 1H8a1 1 0 01-1-1V6a1 1 0 011-1zm6 0h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V6a1 1 0 011-1z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnHoldBold;
